module.exports = __webpack_public_path__ + "static/media/unicorn_dab.65dc36dd.png";